import { PlayerPreview } from './PlayerPreview'
import { Player } from '../assets/data'
interface PlayersTableProps {
  players: Player[]
}

export const PlayersTable = ({ players }: PlayersTableProps) => {
  return (
    <div>
      <div style={{ background: 'red', color: 'white', width: '100%' }}>
        <h2>{players.length} Rock Players</h2>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'space-around',
          width: '100%'
        }}
      >
        {players.map((player) => {
          return <PlayerPreview player={player} key={player.slug} />
        })}
      </div>
    </div>
  )
}
